var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 11.6667C1.66663 8.52417 1.66663 6.9525 2.64329 5.97667C3.61913 5 5.19079 5 8.33329 5H11.6666C14.8091 5 16.3808 5 17.3566 5.97667C18.3333 6.9525 18.3333 8.52417 18.3333 11.6667C18.3333 14.8092 18.3333 16.3808 17.3566 17.3567C16.3808 18.3333 14.8091 18.3333 11.6666 18.3333H8.33329C5.19079 18.3333 3.61913 18.3333 2.64329 17.3567C1.66663 16.3808 1.66663 14.8092 1.66663 11.6667Z",
    stroke: "#101828",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 9.16667C4.16663 8.72464 4.34222 8.30072 4.65478 7.98816C4.96734 7.6756 5.39127 7.5 5.83329 7.5H14.1666C14.6087 7.5 15.0326 7.6756 15.3451 7.98816C15.6577 8.30072 15.8333 8.72464 15.8333 9.16667C15.8333 9.60869 15.6577 10.0326 15.3451 10.3452C15.0326 10.6577 14.6087 10.8333 14.1666 10.8333H5.83329C5.39127 10.8333 4.96734 10.6577 4.65478 10.3452C4.34222 10.0326 4.16663 9.60869 4.16663 9.16667ZM7.49996 14.1667C7.49996 14.4982 7.36826 14.8161 7.13384 15.0505C6.89942 15.285 6.58148 15.4167 6.24996 15.4167C5.91844 15.4167 5.6005 15.285 5.36608 15.0505C5.13166 14.8161 4.99996 14.4982 4.99996 14.1667C4.99996 13.8351 5.13166 13.5172 5.36608 13.2828C5.6005 13.0484 5.91844 12.9167 6.24996 12.9167C6.58148 12.9167 6.89942 13.0484 7.13384 13.2828C7.36826 13.5172 7.49996 13.8351 7.49996 14.1667Z",
    stroke: "#101828",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.58335V10.8334M10.8333 14.1667H15M5.41663 5.00002L12.5 1.66669",
    stroke: "#101828",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioLinear);
export default __webpack_public_path__ + "static/media/radio-linear.17683189811d581122426cba38e2d5b0.svg";
export { ForwardRef as ReactComponent };